export const routePath = {
    home        : `/`,
    categories  : `/categories`,
    movie       : `/movie`,
    movies      : `/movies`,
    topRated    : `/movies`,
    upcoming    : `/movies`,
    invalid     : `/*`
}